module.exports = __webpack_public_path__ + "static/media/news-01.4f6a2ed1.jpg";